import { observer } from 'mobx-react-lite';
import { useIntegratedForm } from '../../../forms/use-integrated-form';
import { BoloPanelFormType } from '@mark43/cad-api';
import { Box, HStack } from '@cad-arc';
import { FormSaveButton } from '../../../forms/integrated-form-components/form-save-button';
import { useFormState } from 'react-hook-form';
import { countDirtyFields } from '../../../event-panel/count-dirty-fields';
import { useBoloPanelMetadata } from '../state/bolo-panel-metadata-context';
import { ExpireAndReactivateBoloButton } from './expire-and-reactivate-bolo-button';
import { BoloExportButton } from './bolo-export-button';

const CreateBoloFooter = observer(function CreateBoloFooter(): React.ReactElement {
    const boloForm = useIntegratedForm<BoloPanelFormType>();
    return (
        <HStack w="100%" justifyContent="flex-end">
            <FormSaveButton onClick={boloForm.onSubmit}>Save</FormSaveButton>
        </HStack>
    );
});

const SavedBoloFooter = observer(function SavedBoloFooter(): React.ReactElement {
    const boloForm = useIntegratedForm<BoloPanelFormType>();
    const metadata = useBoloPanelMetadata();

    const { dirtyFields } = useFormState({
        control: boloForm.form.control,
    });
    const dirtyFieldCount = countDirtyFields(dirtyFields);

    return (
        <HStack w="100%" justifyContent="space-between">
            <ExpireAndReactivateBoloButton />
            <HStack>
                {dirtyFieldCount > 0 && (
                    <FormSaveButton onClick={boloForm.onSubmit}>Save</FormSaveButton>
                )}
                {metadata?.boloId && <BoloExportButton boloId={metadata.boloId} />}
            </HStack>
        </HStack>
    );
});

export const BoloPanelFooter = observer(function BoloPanelFooter(): React.ReactElement {
    const metadata = useBoloPanelMetadata();
    const boloExists = !!metadata?.boloId;

    return (
        <Box w="100%" p={4} bg="surface.foreground" borderTop="sm" borderColor="border.default">
            {boloExists ? <SavedBoloFooter /> : <CreateBoloFooter />}
        </Box>
    );
});
